import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from 'evergreen-ui';

const PopupPhoneContent = ({ inputVal, handleChange }) => {
  return (
    <Fragment>
      <h5>Call to Number</h5>
      <TextInput
        placeholder='Type phone number'
        value={inputVal}
        onChange={(e) => handleChange(e.target.value)}
      />
      <p className='button-popup__hint'>
        <strong>Hint: </strong>
        <span>
          After taping this button on phone, user can make a call to this
          number.
        </span>
      </p>
    </Fragment>
  );
};

PopupPhoneContent.propTypes = {
  inputVal: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default PopupPhoneContent;
